{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              -66.86004522144735,
              44.7969300167328
            ],
            [
              -69.7073027193188,
              44.85550588203603
            ],
            [
              -70.81012826084398,
              43.704712103307344
            ],
            [
              -71.78649522526659,
              42.08661059177547
            ],
            [
              -71.8398235879473,
              41.31475333190724
            ],
            [
              -69.91279736522714,
              41.12537317549297
            ],
            [
              -66.86004522144735,
              44.7969300167328
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}